export default __webpack_public_path__ + "static/media/ic_all_active.2eb1a14b.svg";